<script setup lang="ts">
import SelectMenu from './SelectMenu.vue';
import { useLocale } from '../../i18n/use-locale';
import { LOCALES } from '../../i18n';

withDefaults(defineProps<{ variant?: 'accent' | 'dark'; align?: 'left' | 'right' }>(), {
  variant: 'dark',
  align: 'left',
});

const { current, set } = useLocale();
const options = LOCALES.map((l) => ({ value: l.code, label: l.label }));
</script>

<template>
  <SelectMenu
    :model-value="current"
    :options="options"
    :variant="variant"
    :align="align"
    aria-label="Language"
    @update:model-value="set"
  />
</template>
